import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Icon } from '../icon/index.js';
import type { OfflineProps } from './types.js';

/** `<Offline>` component. */
export const Offline = ({ className, ...props }: OfflineProps): ReactElement => (
  <div
    className={twMerge(
      'grid aspect-video content-center justify-center bg-dark text-base-100 rounded-12',
      className
    )}
    {...props}
  >
    <Icon />
  </div>
);
